import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import API from '../config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // ✅ FIXED: Only non-sensitive fields stored in localStorage.
  // balance, phone, email are omitted — fetched fresh from /api/users/profile.
  // This limits XSS exposure if localStorage is ever read by injected scripts.
  const safeUser = (userData) => ({
  id:             userData.id,
  username:       userData.username,
  full_name:      userData.full_name,
  is_admin:       userData.is_admin,
  is_super_admin: userData.is_super_admin,
  is_verified:    userData.is_verified,
});
  const login = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    localStorage.setItem('token', userToken);
    localStorage.setItem('user', JSON.stringify(safeUser(userData)));
  };

  // Call this after nickname is set or balance updates so it reflects immediately
  const updateUser = (updates) => {
    setUser(prev => {
      const updated = { ...prev, ...updates };
      localStorage.setItem('user', JSON.stringify(safeUser(updated)));
      return updated;
    });
  };

  // ✅ FIXED: localStorage is always cleared even if the API call fails.
  // Previously the clear was inside try{} so a network error left the user
  // appearing logged in with a dead token.
  const logout = async () => {
    try {
      await axios.post(`${API}/api/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (_) {}
    finally {
      setUser(null);
      setToken(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);